<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    <mat-tab>
        <ng-template mat-tab-label>
            <span matBadge="{{vesselNum}}" [matBadgeHidden]="vesselNum === 0" matBadgeOverlap="false"
                class="tab_vessel_badge">Customer's Vessels</span>
        </ng-template>
        <dpi-vessel-list (listSizeChanged)="setVesselNum($event)"> </dpi-vessel-list>
    </mat-tab>
    <mat-tab label="Details">
        <mat-card class="decoration-card">
            <mat-card-content>
                <mat-toolbar *ngIf="!isReadonly">
                    <button mat-icon-button matTooltip="update" (click)="updateCustomer()" [disabled]="!isContentChanged"
                        *ngIf="!isReadonly">
                        <mat-icon>save</mat-icon>
                    </button>

                    <span class="example-spacer"></span>
                    
                <!-- Create and delete of customer is not supported for now, and will consider to add them in the future together with advanced authorization machanism

                    <button mat-icon-button matTooltip="add a customer" (click)="createCustomer()" *ngIf="!isReadonly">
                        <mat-icon>plus_one</mat-icon>
                    </button>

                    <button mat-icon-button matTooltip="delete" (click)="btnDeleteClicked()" *ngIf="!isReadonly">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                -->

                </mat-toolbar>

                <form class="example-form" (change)="onContentChange()">
                    <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                        <mat-label>Customer Name</mat-label>
                        <input type="text" name="inputName" matInput [(ngModel)]="customer.name"
                            [readonly]="isReadonly">
                    </mat-form-field>
                    <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                        <mat-label>Description</mat-label>
                        <textarea type="text" name="textDesc" matInput [(ngModel)]="customer.description"
                            [readonly]="isReadonly"></textarea>
                    </mat-form-field>
                    <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                        <mat-label>Email</mat-label>
                        <input type="email" name="inputEmail" matInput [(ngModel)]="customer.email"
                            [readonly]="isReadonly">
                    </mat-form-field>
                    <mat-form-field class="example-full-width" [appearance]="fieldAppearance">
                        <mat-label>Tel.</mat-label>
                        <input type="text" name="inputTel" matInput [(ngModel)]="customer.tel" [readonly]="isReadonly">
                    </mat-form-field>
                </form>
            </mat-card-content>
        </mat-card>
    </mat-tab>
</mat-tab-group>